import BeneficiaryService from '../services/beneficiary.service'

export const beneficiaryModule = {
  namespaced: true,

  state: {
    beneficiaries: [],
    bsDetail: null,
    beneficiaryService: undefined,
    criterias: null,
    invalidData: null
  },

  actions: {
    async search ({ commit }, criterias) {
      return BeneficiaryService.search(criterias).then(
        response => {
          const beneficiaries = response.data
          commit('searchSuccess', beneficiaries)
          return Promise.resolve(beneficiaries)
        },
        error => {
          commit('searchFailure')
          return Promise.reject(error.response.data || error.response.statusText.replace(' ', '_'))
        }
      )
    },

    async detail ({ commit }, criterias) {
      return BeneficiaryService.detail(criterias).then(
        response => {
          const bsDetail = response.data
          commit('detailSuccess', bsDetail)
          return Promise.resolve(bsDetail)
        },
        error => {
          commit('detailFailure')
          return Promise.reject(error.response.data)
        }
      )
    },

    async reset ({ commit }) {
      commit('listReset')
    },

    async setBeneficiaryService ({ commit }, beneficiaryService) {
      commit('beneficiaryServiceSuccess', beneficiaryService)
    },

    async setCriterias ({ commit }, criterias) {
      commit('setCriterias', criterias)
    },

    async resetCriterias ({ commit }) {
      commit('resetCriterias')
    },

    async invalidData ({ commit }, error) {
      commit('invalidData', error)
    },

    async resetInvalidData ({ commit }) {
      commit('invalidData', null)
    }
  },

  mutations: {
    detailSuccess (state, bsDetail) {
      state.bsDetail = bsDetail
    },
    detailFailure (state) {
      state.bsDetail = null
    },
    listReset (state) {
      state.beneficiaries = []
    },
    searchSuccess (state, beneficiaries) {
      state.beneficiaries = beneficiaries
    },
    searchFailure (state) {
      state.beneficiaries = []
    },
    beneficiaryServiceSuccess (state, beneficiaryService) {
      state.beneficiaryService = beneficiaryService
    },
    setCriterias (state, criterias) {
      state.criterias = criterias
    },
    resetCriterias (state) {
      state.criterias = null
    },
    invalidData (state, error) {
      state.invalidData = error
    }
  }
}
